<ion-header>
  <ion-toolbar color="secondary">
    <ion-buttons slot="start">
      <ion-button (click)="modalCtrl.dismiss()">
        <ion-icon slot="icon-only" name="close-circle"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>ALUMNOS NO AUTORIZAN FOTOS</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content class="ion-padding">
  <p>
    Queremos recordarte que en el aula tienes alumnos que no han firmado sus padres
    la autorización correspondiente para hacerles fotos/vídeos. Puede ser porque no tienen
    actualizada la ficha, porque no han firmado la matrícula o, lo que es más importante,
    <span>porque los padres efectívamente no quieren</span>. Si no queremos tener problemas de
    Protección de Datos en el Centro, recomendamos asegurarse antes de hacer fotos.
  </p>
  @for (a of alumnos; track a.id) {
    <h3>{{a.nombre|uppercase}} {{a.apellido1|uppercase}} {{a.apellido2|uppercase}}</h3>
  }
</ion-content>
